import { Controller } from 'stimulus'; 
export default class extends Controller {

  static targets = ["userTypeSelect", "customerSelect", "phoneNumberText"];

  connect() {
    if (this.hasCustomerSelectTarget)  // this only exists on the admin page
      this.userTypeChange(null);

    const svgs = document.querySelectorAll(".bi-eye");
    svgs.forEach((svg) => this.setPasswordVisibility(svg, false));
  }

  showTarget(target, show) {
    const labelSelector = `label[for=${target.id}]`;
    const label = document.querySelector(labelSelector);

    label.hidden = !show;

    if (show) {
      target.style.display = 'block';
      target.disabled = false;
    }
    else {
      target.style.display = 'none';
      target.disabled = true;
    }
  }
  
  userTypeChange(event) {
    const isCustomer = this.userTypeSelectTarget.value.toLowerCase().includes("customer");

    this.showTarget(this.customerSelectTarget, isCustomer);
    this.showTarget(this.phoneNumberTextTarget, !isCustomer);
  }

  togglePasswordVisibility(event) {
    this.setPasswordVisibility(event.target, null);
  }

  setPasswordVisibility(svg, setVisible) {

    const button = svg.parentElement;
    const inputGroup = button.parentElement;
    const input = inputGroup.querySelector("input");
    const eye = button.querySelector(".bi-eye");
    const eyeSlash = button.querySelector(".bi-eye-slash");

    if (setVisible == null)
      setVisible = !eye.classList.contains("d-none")  // if eye is visible, then we need to set visible

    if (setVisible) {
      input.type = "text";
      eye.classList.add("d-none");
      eyeSlash.classList.remove("d-none");
    }
    else {
      input.type = "password";
      eyeSlash.classList.add("d-none");
      eye.classList.remove("d-none");
    }
  }

}
